import { makeStyles } from '@material-ui/core';
import { useUrlState } from '@zennya/web-component-library/src';
import { mapActionTypeToStep } from 'pages/CustomerBookingCreate/2.2/ServicePackages/processor';
import { START_STEP, STEP_RECIPIENT } from 'pages/CustomerBookingCreate/constants';
import { bookingState, cartVisibleState, clearCartState, isCartPrefilledState, packagesState, prefillCartState, servicesState, skipStepState, stepState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getFeaturedCategories, getServiceDetails } from 'services/service.service';
import { ArrayParam, StringParam, useQueryParam } from 'use-query-params';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
}));
const useExternalLinkProcessor = () => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState);
  const [clearCart, setClearCart] = useRecoilState(clearCartState);

  const [prefillCart, setPrefillCart]= useRecoilState(prefillCartState);
  const [isCartPrefilled, setIsCartPrefilled]= useRecoilState(isCartPrefilledState);
  const [serviceItemName, setServiceItemName] = useUrlState({
    queryKey: 'item',
    defaultValue: '',
  })

  const trackEvent = useTrackEvent()
  const history = useHistory()

  const fetchCategory = useCallback(
    async () => {
      try {
        trackEvent('Open From Prefilled Link', { serviceItemName })
        setClearCart(true)
        setPrefillCart(serviceItemName)
        setIsCartPrefilled(true)
        setStep(START_STEP)
        history.replace(START_STEP, { internal: true })

        // const category = await getServiceDetails({ serviceId: typeId })
        // const fillOptions = mapActionTypeToStep(action)
        // if (fillOptions?.canAddToCart) {
        //   setEnableCart(true)
        // } else {
        //   setEnableCart(false)
        // }
        // setClearCart(true)
        
        // const pkgs = category?.extended_packages?.filter(pkg => {
        //   return packageIds?.includes(`${pkg?.id}`)
        // })
        // const srvs = category?.extended_package_items?.filter(srv => {
        //   return serviceIds?.includes(`${srv?.id}`)
        // })
        // setPackages(pkgs)
        // setServices(srvs)
        // setBooking({
        //   ...booking,
        //   serviceCategory: category,
        // })
        // setIsCartPrefilled(true)
        // setSkipStep(fillOptions?.destinationStep)
        // setStep(STEP_RECIPIENT)
        // history.replace(STEP_RECIPIENT, { internal: true })
      } catch (error) {
        trackEvent('Prefilled link error', { error: error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details })
      }
    },
    [],
  );
  useEffect(
    () => {
      if (serviceItemName) {
        fetchCategory()
      }
    }, [serviceItemName]
  );
  return null
}

export { useExternalLinkProcessor }